<template>
  <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
    <Loading v-show="loading"/>
    <!--[html-partial:include:{"file":"partials\/_header-base.html"}]/-->
    <div v-show="!loading"
         class="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
         id="kt_content">
      <div class="kt-container">
        <div class="kt-portlet kt-margin-top-30" id="content-portlet">
          <div class="kt-portlet__head app__portlet-head">
            <div class="kt-portlet__head-label">
              <h3 class="kt-portlet__head-title">
                Составление заявки в Сервис Деск
              </h3>
            </div>
          </div>

          <div v-if="criticalErrorsList && criticalErrorsList.length > 0"
               class="kt-portlet__body app_service__form-body">
            <div v-for="error in criticalErrorsList"
                 class="alert alert-warning fade show"
                 role="alert">
              <div class="alert-icon"><i class="flaticon-warning"></i></div>
              <div class="alert-text">{{ error }}</div>
            </div>
          </div>

          <!--begin::Form-->
          <form v-else class="kt-form app_service__form" name="sd_service_call"
                enctype="multipart/form-data"
                v-on:submit.prevent="saveServiceCall()">

            <template v-if="errorsList">
              <div v-for="error in errorsList"
                   class="alert alert-warning fade show"
                   role="alert">
                <div class="alert-icon"><i class="flaticon-warning"></i></div>
                <div class="alert-text">{{ error }}</div>
                <div class="alert-close">
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true"><i class="la la-close"></i></span>
                  </button>
                </div>
              </div>
            </template>

            <div class="kt-portlet__body app_service__form-body">
              <vue-form-generator :schema="schema" :model="model"
                                  @validated="onValidated"
                                  @model-updated="onModelUpdated"
                                  :options="formOptions"></vue-form-generator>
              <div class="form-group form-group-last app_service__form--add-file-input">
                <a href="javascript:void(0)" title="добавить еще один файл"
                   v-on:click="addFileInput">+ еще один файл</a>
              </div>
            </div>

            <div class="kt-portlet__foot">
              <div class="kt-form__actions">
                <div class="row">
                  <div class="col-xl-3"></div>
                  <div class="col-xl-6">

                    <div v-if="errorsList">
                      <div class="alert alert-warning" role="alert" v-for="error in errorsList">
                        Ошибка: {{error}}
                      </div>
                    </div>

                    <button type="submit" class="btn btn-brand app__btn">
                      Отправить
                    </button>&nbsp;
                    <router-link :to="{name: 'home'}" class="btn btn-secondary app__btn">
                      Отменить
                    </router-link>
                  </div>
                  <div class="col-xl-3"></div>
                </div>
              </div>
            </div>
          </form>
          <!--end::Form-->
        </div>
      </div>
      <!--[html-partial:include:{"file":"partials\/_footer-base.html"}]/-->
    </div>
  </div>
</template>

<script>
import Api from '../Api';
import router from '../router';
import Loading from '../components/Loading';
import FileUploader from '../modules/FileUploader';

export default {
  name: 'ServiceCallCreate',
  data() {
    const data = {
      loading: true,
      criticalErrorsList: [],
      errorsList: [],
      validationErrorsList: [],
      isValid: false,
      user: {
        id: 0,
      },
      model: {
        NAME: '',
      },
      serviceAgreements: {},
      schema: {
        fields: [],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
        validateAsync: true,
      },
    };
    const agreementFieldId = this.$root.app_data.service_call.fields.AGREEMENT.field_id;
    data.model[agreementFieldId] = '';

    const typeFieldId = this.$root.app_data.service_call.fields.TYPE.field_id;
    data.model[typeFieldId] = '';
    data.schema.fields.push({
      required: true,
      type: 'select',
      selectOptions: {
        hideNoneSelectedText: true,
        noneSelectedText: 'Выберите тип заявки',
      },
      label: 'Тип заявки',
      model: typeFieldId,
      inputName: `FIELDS[${typeFieldId}]`,
      code: 'type',
      values: [],
      validator: this.requiredValidator,
    });

    const serviceFieldId = this.$root.app_data.service_call.fields.SERVICE.field_id;
    data.model[serviceFieldId] = '';
    data.schema.fields.push({
      required: true,
      type: 'select',
      selectOptions: {
        hideNoneSelectedText: true,
        noneSelectedText: 'Выберите услугу',
      },
      label: 'Услуга',
      model: serviceFieldId,
      inputName: `FIELDS[${serviceFieldId}]`,
      code: 'service',
      values: [],
      validator: this.requiredValidator,
    });

    data.schema.fields.push({
      type: 'input',
      inputType: 'text',
      label: 'Тема',
      model: 'NAME',
      placeholder: 'Введите тему',
      featured: true,
      required: true,
      validator: this.requiredValidator,
    });

    const descriptionFieldId = this.$root.app_data.service_call.fields.DESCRIPTION.field_id;
    data.model[descriptionFieldId] = '';
    data.schema.fields.push({
      type: 'textArea',
      label: 'Описание',
      model: descriptionFieldId,
      inputName: `FIELDS[${descriptionFieldId}]`,
      placeholder: 'Введите описание',
      featured: true,
      required: true,
      validator: this.requiredValidator,
    });

    data.schema.fields.push({
      type: 'upload',
      // inputType: 'file',
      inputName: 'files[]',
      label: 'Файл',
      placeholder: 'Файл',
      featured: true,
      // required: true,
      multiple: true,
      multi: true,
    });

    return data;
  },
  methods: {
    requiredValidator(value, field, model) {
      if (!value) {
        return [`Поле "${field.label}" обязательное`];
      }
    },
    onModelUpdated(newVal, modelProp, test) {
      const serviceFieldId = this.$root.app_data.service_call.fields.SERVICE.field_id;
      const agreementFieldId = this.$root.app_data.service_call.fields.AGREEMENT.field_id;

      if (modelProp === serviceFieldId) {
        if (this.serviceAgreements[newVal]) {
          this.model[agreementFieldId] = this.serviceAgreements[newVal][0];
        }
      }
    },
    uploadFiles(listElementId) {
      return new Promise((resolve, reject) => {
        const diskPath = `/service_call_files/${listElementId}`;
        const fileInputs = document.querySelectorAll('.app_service__form input[type=file]');

        const filesUploaded = FileUploader.uploadToDisk(diskPath, fileInputs);

        filesUploaded.then((uploadedFileIDs) => {
          resolve(uploadedFileIDs);
        });

        filesUploaded.catch((reason) => {
          reject(reason);
        });
      });
    },
    attachFilesToServiceCall(params, uploadedFileIds) {
      return new Promise((resolve, reject) => {
        const diskPropId = this.$root.app_data.service_call.fields.DISK.field_id;

        params.FIELDS[diskPropId] = uploadedFileIds;

        window.BX24.callMethod(
          'lists.element.update',
          params,
          (result) => {
            if (result.error()) {
              reject(result.error());
            } else {
              resolve();
            }
          },
        );
      });
    },
    onValidated(isValid, errorsList) {
      this.isValid = isValid;

      this.validationErrorsList = [];
      if (errorsList.length > 0) {
        errorsList.forEach((el) => {
          this.validationErrorsList.push(el.error);
        });
      }
    },
    saveServiceCall() {
      this.errorsList = [];
      if (!this.isValid) {
        this.errorsList = this.validationErrorsList;
        return;
      }

      this.loading = true;
      this.errorsList = [];
      const timestamp = new Date().getTime();
      const params = {
        IBLOCK_TYPE_ID: 'lists',
        IBLOCK_CODE: 'sd_service_call',
        ELEMENT_CODE: `request_${timestamp}`,
        FIELDS: this.model,
      };
      params.ELEMENT_CODE += `_${this.$root.app_data.current_user.ID}`;

      window.BX24.callMethod(
        'lists.element.add',
        params,
        (result) => {
          if (result.error()) {
            this.errorsList.push(result.error());
            this.loading = false;
          } else {
            delete params.ELEMENT_CODE;
            params.ELEMENT_ID = result.data();
            const filesUploaded = this.uploadFiles(params.ELEMENT_ID);
            filesUploaded.then((uploadedFileIds) => {
              if (uploadedFileIds.length > 0) {
                const filesAttached = this.attachFilesToServiceCall(params, uploadedFileIds);
                filesAttached.then(() => {
                  this.sendToQueue(params.ELEMENT_ID);
                });

                filesAttached.catch((error) => {
                  this.errorsList.push(error);
                  this.loading = false;
                });
              } else {
                this.sendToQueue(params.ELEMENT_ID);
              }
            });

            filesUploaded.catch((error) => {
              this.errorsList.push(error);
              this.loading = false;
            });
          }
        },
      );
    },
    sendToQueue(elementId) {
      if (this.errorsList.length > 0) {
        this.loading = false;
      } else {
        const request = Api.startServiceCallProcessing(elementId);
        request.then((response) => {
          if (response.data.sent) {
            router.push({ name: 'service.sent', params: { result: 'ok' } });
          } else {
            router.push({ name: 'service.sent', params: { result: 'fail' } });
          }
        });
        request.finally(() => {
          this.loading = false;
        });
      }
    },
    addFileInput() {
      this.schema.fields.push({
        type: 'upload',
        // inputType: 'file',
        label: 'Файл',
        inputName: 'files[]',
        placeholder: 'Файл',
        featured: true,
      });

      let height = document.getElementById('app').clientHeight;
      if (height < 750) {
        height = 750;
      }
      window.BX24.resizeWindow(
        document.body.clientWidth,
        height + 150,
      );
    },
    fetchData() {
      this.loading = true;
      const request = Api.getFormData();
      request.then((response) => {
        if (response.data.errors && response.data.errors.length > 0) {
          response.data.errors.forEach((el) => {
            this.criticalErrorsList.push(el);
          });
        } else {
          // available types
          this.setAvailableTypes(response.data.types);

          // available services
          this.setAvailableServices(response.data.formServices);

          // available service agreements
          this.setAvailableAgreements(response.data.serviceAgreements);
        }
      });

      request.finally(() => {
        this.loading = false;
      });
    },
    setAvailableTypes(typesList) {
      const fieldTypes = this.schema.fields.find(field => field.code === 'type');
      Object.keys(typesList).forEach((type) => {
        fieldTypes.values.push({ id: type, name: typesList[type] });
      });

      // default value
      if (fieldTypes.values.length > 0) {
        this.model[fieldTypes.model] = fieldTypes.values[0].id;
      }
    },
    setAvailableServices(servicesList) {
      const fieldServices = this.schema.fields.find(field => field.code === 'service');
      Object.keys(servicesList).forEach((uuid) => {
        fieldServices.values.push({
          id: uuid,
          name: servicesList[uuid],
        });
      });

      // default value
      if (fieldServices.values.length > 0) {
        this.model[fieldServices.model] = fieldServices.values[0].id;
      }
    },
    setAvailableAgreements(agreementsList) {
      this.serviceAgreements = agreementsList;

      // default value
      const serviceFieldId = this.$root.app_data.service_call.fields.SERVICE.field_id;
      const agreementFieldId = this.$root.app_data.service_call.fields.AGREEMENT.field_id;

      if (this.model[serviceFieldId]) {
        const currentService = this.model[serviceFieldId];

        if (this.serviceAgreements[currentService]) {
          this.model[agreementFieldId] = this.serviceAgreements[currentService][0];
        }
      }
    },
  },
  components: {
    Loading,
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: 'fetchData',
  },
};
</script>

<style lang="scss">
  .app__portlet-head {
    font-family: "Roboto", serif;
  }

  .app_service__form-body {
    font-family: "Roboto", serif;

    fieldset {
      max-width: 900px;
      margin: 0 auto;
    }
  }

  .app_service__form--add-file-input {
    a {
      display: block;
      max-width: 900px;
      margin: 0 auto;
      text-align: left;
    }
  }
</style>
